import { render, staticRenderFns } from "./list_sort_suggest.vue?vue&type=template&id=5044b0be&"
import script from "./list_sort_suggest.vue?vue&type=script&lang=js&"
export * from "./list_sort_suggest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports